// Brand: PizzaExpress
// Flow: PreOrder

import React from 'react'

import PreOrderDataCapture from "../../../components/PreOrderDataCapture"
import withAppState from '../../../mobx/withAppState';
import { Steps } from '../../../lib/constants';

import milogo from '../../../assets/milano/milano_logo.png';


const PreOrderMenuDataCaptureWrapper = (props) => {
  const continueButtonHandler = () => { 
    props.goToStepWithoutHistory(Steps.PRE_ORDER); 
  }

  const logo = (
    <div className="company-logo large milano-logo">
      <a href="#">
      <img src={milogo} alt="Milano" />
      </a>
    </div>
  )

  return <PreOrderDataCapture 
    logo={logo}
    continueButtonHandler={continueButtonHandler}
    testAndTraceTitle="Contact Tracing and Active Follow Up"
    testAndTraceDescription="In order to support the HSE Irish healthcare system following the COVID-19 outbreak, all restaurants have been asked by the HPSC to keep a record of one customer at each table. This information will be provided, if requested, to the Contact tracing Centre (CTC) to help contain clusters or outbreaks and control the virus. Your information will be handled strictly in accordance with our "
    hideSkip={true}
    allowIrishPhoneNumbers={true}
  />
}

export default withAppState(PreOrderMenuDataCaptureWrapper, {
  mobXActions: ({
    goToStepWithoutHistory,
    popStep,
  }) => ({
    goToStepWithoutHistory,
    popStep,
  })
});